import React, { Component } from 'react';
import { OverlayTrigger, Popover } from 'react-bootstrap';
import { GeoAltFill } from 'react-bootstrap-icons';
import Elements2ChartImage from '../../images/Elements2_Chart.png';

export class Elements2Chart extends Component {
    render() {
        const popover = (
            <Popover className="popover-basic">
                <Popover.Title as="h3">Elements 2 Chart</Popover.Title>
                <Popover.Content>
                    <img src={Elements2ChartImage} className="popover-images" alt="Elements 2 Chart" />
                </Popover.Content>
            </Popover>
        );

        return (
            <OverlayTrigger
                trigger="click"
                placement="auto"
                overlay={popover}
                rootClose={true}
                transition={false}
                onToggle={() => this.setState({ error: null })}
            >
                <div className="game-icons years-alpha" style={this.props.positioning}>
                    <GeoAltFill alt="Elements 2 Chart Clue" />
                </div>
            </OverlayTrigger>
        )
    }
}

export default Elements2Chart
